import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux"; 
import ReportsCard from "./ReportsCard";
import totalServiceProviderIcon from "../../images/icons/totalServiceProviderIcon.svg";
import activeServiceProviderIcon from "../../images/icons/activeServiceProviderIcon.svg";
import inactiveServiceProviderIcon from "../../images/icons/inactiveServiceProviderIcon.svg";
import totalValueItem from "../../images/icons/totalValueItem.svg";
import CustomeTable from "../../components/widget/CustomeTable";

const ThirdPartyServiceReports = (props) => {
  // const { t } = useTranslation();
  const [datas, setDatas] = useState([]);
  const { sales } = useSelector((state) => state.SalesReport);
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    props.getAssetsFromToDateAll(
      props?.hotel?._id,
      props?.fromDate,
      props?.toDate
    );
  }, [props?.fromDate, props?.toDate]);

  useEffect(() => {
    if (sales && Array.isArray(sales) && sales?.length) {
      let expense = sales?.map((d) => {
        return {
          serviceID: d?.serviceID,
          serviceName: d?.serviceName,
          vendorName: d?.vendorName,
          category: d?.category,
          date: d?.date,
          amount: d?.amount,
          paymentMethod: d?.paymentMethod,
          invoiceNo: d?.invoiceNo,
        };
      });
      setDatas(expense);
    }
  }, [sales]);

  const tableData = [
    {
      serviceID: "P001",
      serviceName: "Puja Stage",
      vendorName: "ABC Supplies",
      category: "Event",
      date: "2024-01-12",
      amount: "$100",
      paymentMethod: "Card",
      invoiceNo: "INV-001",
    },
    {
      serviceID: "P002",
      serviceName: "Puja Stage",
      vendorName: "ABC Supplies",
      category: "Event",
      date: "2024-01-12",
      amount: "$100",
      paymentMethod: "Card",
      invoiceNo: "INV-002",
    },
    {
      serviceID: "P003",
      serviceName: "Puja Stage",
      vendorName: "ABC Supplies",
      category: "Event",
      date: "2024-01-12",
      amount: "$100",
      paymentMethod: "Card",
      invoiceNo: "INV-003",
    },
    {
      serviceID: "P004",
      serviceName: "Puja Stage",
      vendorName: "ABC Supplies",
      category: "Event",
      date: "2024-01-12",
      amount: "$100",
      paymentMethod: "Card",
      invoiceNo: "INV-004",
    },
    {
      serviceID: "P005",
      serviceName: "Puja Stage",
      vendorName: "ABC Supplies",
      category: "Event",
      date: "2024-01-12",
      amount: "$100",
      paymentMethod: "Card",
      invoiceNo: "INV-005",
    },
  ];

  const columnDefs = [
    {
      headerName: "Service ID",
      field: "serviceID",
      minWidth: 150,
      checkboxSelection: true,
      headerCheckboxSelection: true,
    },
    {
      headerName: "Service Name",
      field: "serviceName",
      filter: true,
    },
    {
      headerName: "Vendor Name",
      field: "vendorName",
      filter: true,
    },
    {
      headerName: "Category",
      field: "category",
      filter: true,
    },
    {
      headerName: "Date",
      field: "date",
      filter: true,
    },
    {
      headerName: "Amount",
      field: "amount",
      filter: true,
    },
    {
      headerName: "Payment Method",
      field: "paymentMethod",
      filter: true,
    },
    {
      headerName: "Invoice No",
      field: "invoiceNo",
      filter: true,
    },
  ];
  return (
    <div className=" page-container">
      <div className="grid grid-cols-4 items-center gap-4 my-4">
        <ReportsCard
          icon={totalServiceProviderIcon}
          iconBgColor={"bg-[#F1FADF]"}
          heading={"Total Service Provider"}
          value={"1258"}
        />
        <ReportsCard
          icon={activeServiceProviderIcon}
          iconBgColor={"bg-[#E8EBFF]"}
          heading={"Active Service Provider"}
          value={"800"}
        />
        <ReportsCard
          icon={inactiveServiceProviderIcon}
          iconBgColor={"bg-[#FCEEDD]"}
          heading={"Inactive Service Provider"}
          value={"1258"}
        />
        <ReportsCard
          icon={totalValueItem}
          iconBgColor={"bg-[#FCEAEA]"}
          heading={"Total Cost"}
          value={"$3000"}
        />
      </div>
      {/* {datas && datas?.length ? ( */}
      <CustomeTable
        tableName={"Third Party Service Report table"}
        columnDefs={columnDefs}
        rowData={tableData}
        setSelectedRows={setSelectedRows}
      />
      {/* ) : null} */}
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.AssetsReport,
});

const mapDispatchToProps = (dispatch) => ({ 
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ThirdPartyServiceReports);
